module.exports = __webpack_public_path__ + "img/code_bg.23f80d0b.png";